module.exports = __webpack_public_path__ + "static/media/ico-tu-informacion-inact.3c806e6e.svg";